let audio = null;

export const playNotifSound = () => {
  try {
    if (!audio) audio = new Audio("/notif-audio.mp3");
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch (_) {}
};
